import { z } from "zod";
import { NameSchema, OptionalPhoneSchema } from "./user";
import { ProfileLeadStatusSchema } from "./profileLeadStatus";

export const LeadSchema = z.object({
	id: z.string(),
	firstName: NameSchema.transform((str) => str?.trim() ?? ""),
	lastName: NameSchema.transform((str) => str?.trim() ?? ""),
	email: z
		.string()
		.email({ message: "אמייל לא תקין" })
		.transform((str) => str.trim()),
	phone: OptionalPhoneSchema.transform((str) => str?.trim() ?? "").optional(),
	notes: z.string().optional(),
	createdAt: z.number().optional(),
	// Admin-managed relationship status. nullish = not set yet (backwards-compat
	// with existing lead docs that pre-date this field).
	status: ProfileLeadStatusSchema.nullish(),
});

export const NewLeadSchema = LeadSchema.omit({ id: true }).extend({
	createdAt: z.union([z.date(), z.number()]).optional(),
});

export type TLead = z.infer<typeof LeadSchema>;
export type TNewLead = z.infer<typeof NewLeadSchema>;
